import {useContext} from "react";
import {SettingsContext} from "../SettingsProvider";

const useSettings = () => useContext(SettingsContext);

export default useSettings;